import './App.scss'
import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import { TopBar } from './lib'
import Home from './home/Home'
import Dash from './dash/Dash'
import SignIn from './auth/SignIn'
import Assess from './assess/Assess'
import AssessChoice from './assess/AssessChoice'
import AssessSubmit from './assess/AssessSubmit'
import AssessResult from './assess/AssessResult'
import { authStore, assessStore, resultStore } from './stores'

class App extends Component {
  componentDidMount () {
    assessStore.loadInvite(window.location.search)
    authStore.listenToAuth()
    resultStore.init()
  }

  render () {
    return (
      <Router>
        <div className='App'>
          <TopBar />
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/assess/:type' component={Assess} />
            <Route path='/assess' component={AssessChoice} />
            <Route path='/submit' component={AssessSubmit} />
            <Route path='/results' component={AssessResult} />
            <Route path='/signin' component={SignIn} />
            <Route path='/dashboard' component={Dash} />
          </Switch>
        </div>
      </Router>
    )
  }
}

App.displayName = 'App'

export default observer(App)



// WEBPACK FOOTER //
// ./src/App.js